import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import { trackPageView } from '../utils/analytics'

const Layout = ({ children }) => {
  const location = useLocation()

  useEffect(() => {
    // Track page views
    trackPageView(location.pathname)

    // Scroll to top on route change
    window.scrollTo(0, 0)
  }, [location])

  return (
    <div className="flex flex-col min-h-screen">
      {/* Skip to content link for accessibility */}
      <a href="#main-content" className="skip-to-content">
        Skip to content
      </a>

      <Header />

      <main id="main-content" className="flex-grow">
        {children}
      </main>

      <Footer />
    </div>
  )
}

export default Layout
